import React from 'react';
import { useEffect } from 'react';

import Row from '@amzn/meridian/row';
import Text from '@amzn/meridian/text';
import AppliedFilterTags from 'src/components/shared/appliedFilterTags/appliedFilterTags';
import LoadingSpinner from 'src/components/shared/loadingSpinner/loadingSpinner';
import PaginationWithDropdown from 'src/components/shared/paginationWithDropdown/paginationWithDropdown';
import {
  getAllSites,
  getBuildingTypes,
  getCountries,
  getOrgs,
  getRegions,
  getSubOrgs,
  removeTagAndUpdateFilters,
  setCurrentPage,
  setPerPage,
  setSearchField,
} from 'src/store/adminConfigPageSlice/siteConfigPageSlice/siteConfigPageSlice';
import { useAppDispatch, useAppSelector } from 'src/store/store';

import AdvancedFilterSheet from './advandedFilterSheet/advancedFilterSheet';
import SiteModal from './siteModal/siteModal';
import SiteTable from './siteTable/siteTable';
import TopOptions from './topOptions/topOptions';

const SiteConfiguration = () => {
  const dispatch = useAppDispatch();
  const { isLoading, currentPage, totalPages, perPage, filterTags } = useAppSelector((state) => state.siteConfigPage);
  const { userLoading } = useAppSelector((state) => state.user);

  useEffect(() => {
    if (userLoading === 'fulfilled') {
      dispatch(getAllSites());
      dispatch(getCountries());
      dispatch(getRegions());
      dispatch(getOrgs());
      dispatch(getSubOrgs());
      dispatch(getBuildingTypes());
    }
    return () => {
      dispatch(setSearchField(''));
    };
  }, [dispatch, userLoading]);

  return (
    <div className="view-and-edit-tasks">
      <Row>
        <Text alignment="center">
          Site configuration allows you to view, edit, and update sites viewable within the RTW tool.
        </Text>
      </Row>

      {!isLoading ? (
        <>
          <TopOptions />
          <AppliedFilterTags filterTags={filterTags} onDismissTag={(tag) => dispatch(removeTagAndUpdateFilters(tag))} />
          <SiteTable />
          <AdvancedFilterSheet />
          <SiteModal />
          <PaginationWithDropdown
            currentPage={currentPage}
            totalPages={totalPages}
            perPage={perPage}
            setPerPage={(newPerPage) => dispatch(setPerPage(newPerPage))}
            setCurrentPage={(newPage) => dispatch(setCurrentPage(newPage))}
          />
        </>
      ) : (
        <LoadingSpinner />
      )}
    </div>
  );
};

export default SiteConfiguration;
